const {
  VUE_APP_GATEWAY_HTTP: GATEWAY_HTTP,
  VUE_APP_PUBLIC_HASH: PUBLIC_HASH,
  VUE_APP_FORMS_API: FORMS_API,
} = process.env;

export { GATEWAY_HTTP, PUBLIC_HASH, FORMS_API };
